import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI/_Legacy'

export const Container = styled(Flex)`
  flex-direction: column;
  width: 100%;
`

export const List = styled(Flex)`
  flex-direction: column;
  width: 100%;
  gap: 32px;
`

export const Item = styled(Flex)`
  flex-direction: column;
  width: 100%;
  padding-bottom: 32px;
  border-bottom: 1px solid ${themeGet('colors.border.slight')};

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }
`
